import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import { abbreviateNumericValue } from '@openx/utils/lib/abbreviateNumericValue.ts';
import { useTranslation } from 'react-i18next';
import { LeadingStatsGridItem } from './stats/LeadingStatsGridItem.tsx';
import { StatsItem } from './stats/StatsItem.tsx';

export type DealPromptAudienceTileStatsProps = {
  activeIPs?: number;
  avgCPM?: number;
  reach?: number;
  relevance?: number;
  numberOfSegments?: number;
};

export const DealPromptAudienceTileStats = ({
  activeIPs,
  avgCPM,
  reach,
  relevance,
  numberOfSegments,
}: DealPromptAudienceTileStatsProps) => {
  const { t } = useTranslation();

  const activeIPsValue = abbreviateNumericValue(activeIPs, { decimalPlaces: 2 });
  const avgCPMValue = `$${abbreviateNumericValue(avgCPM, { decimalPlaces: 2 })}`;

  const reachValue = abbreviateNumericValue(reach, { decimalPlaces: 2 });
  const relevanceValue = `${abbreviateNumericValue(relevance, { decimalPlaces: 0 })}%`;
  const numberOfSegmentsValue = abbreviateNumericValue(numberOfSegments, { decimalPlaces: 0 });

  return (
    <Stack spacing={1.5} sx={{ pt: 2, pb: 1, width: '100%', alignItems: 'center' }}>
      <Grid container size={12} sx={{ px: 1, width: '100%' }}>
        <LeadingStatsGridItem label={t('Unique Users')} value={reachValue} dataTest="unique-users" />

        <LeadingStatsGridItem label={t('Avg CPM')} value={avgCPMValue} dataTest="avg-cpm" />

        <LeadingStatsGridItem label={t('Relevance')} value={relevanceValue} dataTest="relevance" />
      </Grid>

      <Divider sx={{ width: '92%' }} data-test="divider" />

      <Stack sx={{ width: '100%', px: 2 }}>
        <StatsItem label={t('Active IPs')} value={activeIPsValue} dataTest="active-ips" />

        <StatsItem label={t('Number of Segments')} value={numberOfSegmentsValue} dataTest="number-of-segments" />
      </Stack>
    </Stack>
  );
};
